export default __webpack_public_path__ + "static/media/eco-image.555bd7a3.webp";